import type { CreatureCarryWeightInput, CreatureCarryWeightResult } from '../types';

const numeric = (value: unknown): number => {
    const number = Number(value ?? 0);
    return Number.isFinite(number) ? number : 0;
};

/** Sum precompiled top-level inventory weights, excluding fully private rows. */
export function compileCreatureCarryWeight(input: CreatureCarryWeightInput): CreatureCarryWeightResult {
    let totalWeightHeld = 0;
    for (const row of input.inventoryRows) {
        if (row === null || row.privateMode === 2) continue;
        totalWeightHeld += numeric(row.grossWeight ?? row.totalWeight ?? 0);
    }
    return {
        total_weight_held: totalWeightHeld,
        gross_weight: numeric(input.creatureWeight) + totalWeightHeld,
    };
}
